module.exports = {
	"header": {
		"subtitle": "A calendar of UHC matches from {{ reddit }}."
	},
	"navbar": {
		"matches": "Matches",
		"generator": "Hosting",
		"settings": "Settings",
		"about": "About"
	},
	"appcache": {
		"checking": "Checking for updates...",
		"progress": "Downloading new update - <strong>{{ progress }}%</strong>",
		"reload": {
			"button": "RELOAD",
			"message": "to apply the new update"
		},
		"error": "Error caching app on device, your browser may not support it.",
		"downloading": "Downloading new update..."
	},
	"buttonRemovalList": {
		"noItems": "Nothing here!"
	},
	"clockbar": {
		"synced": "Synced with server. Offset: {{ formattedOffset() }}",
		"resyncTooltip": "Click this to re-sync time with the server",
		"timezoneTooltip": "Click to go to settings page to edit",
		"wrongTimezone": "You are not using the detected timezone '{{ guessedTimeZone }}' Click this icon to switch to it.",
		"unsynced": "Time has not been synced yet",
		"unsyncedIconTooltip": "The time failed to sync with the server, time may be wrong",
		"nightmode": "Click this to toggle night mode"
	},
	"notifications": {
		"dismiss": "Dismiss",
		"enable": {
			"message": "Click me to enable Desktop notifications",
			"info": "Enable to get notifications when games are starting soon",
			"notice": "Notifications enabled!"
		},
		"denied": {
			"info": "To renable notifications in Chrome click on the page icon to the left of the URL and change the value for 'Notifications'. Other browsers require google-fu",
			"message": "Desktop alerts are blocked, no notifications can be made."
		},
		"unsupported": {
			"message": "Desktop alerts are not supported by your browser, no notifications will be made."
		},
		"notification": "Game opens in {{ time }}"
	},
	"footer": {
		"author": "Brought to you by {{ author }}",
		"source": "Source code on {{ link }}"
	},
	"post": {
		"communityGame": "Community Game",
		"favourite": "Favourite",
		"blocked": "Blocked",
		"tooltips": {
			"opens": "Time Match Opens",
			"toggleFavourite": "Toggle Favorite",
			"teams": "Team Style",
			"gamemodes": "Gamemodes",
			"region": "Server Region",
			"posted": "Time posted in advance of game opening",
			"role": "Roles: {{ getRoleText() }}",
			"version": "Server version"
		},
		"inAdvance": "in advance",
		"matchpost": "Open on hosts.uhc.gg",
		"copy": {
			"initial": "Copy to clipboard",
			"copied": "Copied!",
			"failed": "Failed to copy to clipboard, please copy manually",
			"fallback": "Press Ctrl + C"
		}
	},
	"uniqueItems": {
		"noItems": "No Items",
		"required": "Please enter a value",
		"alreadyInArray": "This item is already in the list"
	},
	"about": {
		"summary": "This website is a collection of upcoming UltraHardcore games hosted by users on {{ link }}",
		"title": "About",
		"version": "Running version {{ version }}",
		"contributors": "Contributors",
		"libraries": "Bundled Front-end Libraries"
	},
	"post404": {
		"title": "404 - Not Found",
		"header": "No post with the id {{ id }} was found",
		"tryAgain": "Try Again Now",
		"reload": "Will automatically attemtpt to load the post details again in {{ seconds }} seconds"
	},
	"list": {
		"filters": {
			"searchPlaceholder": "Search filter",
			"favourites": "Show favourited only:",
			"blocked": "Show blocked:",
			"region": "Regions:",
			"teams": "Team Types:",
			"gamemodes": "Gamemodes:",
			"tab": "Filter Posts - Showing <b>{{ showing }}</b> of <b>{{ all }}</b>"
		},
		"error": "Failed to load matches from the server",
		"configure": "Configure",
		"refresh": "Refresh",
		"updated": "Last Updated:",
		"help": "Help",
		"changelog": "Changelog"
	},
	"settings": {
		"timezone": {
			"header": "Timezone",
			"info": "Timezone for all times/dates on the website:",
			"detected": "Use detected timezone: {{ timezone }}"
		},
		"timeFormat": {
			"header": "Time Format",
			"info": "Time format to for the website:"
		},
		"language": {
			"header": "Language",
			"inUse": "Using language code:"
		},
		"notifications": {
			"header": "Notifications",
			"info": "When to send notifications before a game opens:",
			"add": "Add new notification",
			"sounds": {
				"play": "Play sounds",
				"silent": "Do not play sounds"
			}
		},
		"favourites-author": {
			"header": "Favourite Hosts",
			"none": "No hosts are currently favourited",
			"required": "Please enter a host's username (without /u/)",
			"contained": "This username is already in your favourites"
		},
		"blocked-author": {
			"header": "Blocked Hosts",
			"none": "No hosts are currently blocked",
			"required": "Please enter a host's username (without /u/)",
			"contained": "This username is already in your blocked list"
		},
		"favourites-tag": {
			"header": "Favourite Tags",
			"none": "No tags are currently favourited",
			"required": "Please enter a tag",
			"contained": "This tag is already in your favourites"
		},
		"blocked-tag": {
			"header": "Blocked Tags",
			"none": "No tags are currently blocked",
			"required": "Please enter a tag",
			"contained": "This tag is already in your blocked list"
		},
		"clearData": "Reset all settings/data",
		"importexport": "Import/Export Settings",
		"exportSettings": "Export Settings",
		"importSettings": "Import Settings"
	},
	"changelog": {
		"header": "Changelog"
	},
	"DateTime": {
		"autoTimezone": {
			"message": "The calendar has automatically set your timezone to {{ timezone }}. This will only happen once, go to the settings page if you want to change it.",
			"close": "Close"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/services/translations/en.json
// module id = 157
// module chunks = 0